import { render, staticRenderFns } from "./TaskMoneyConfigprovince.vue?vue&type=template&id=198bb791&"
import script from "./TaskMoneyConfigprovince.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigprovince.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigprovince.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports